/* Refonte V4 mobile — zone content (pages, contact, journal, articles, 404, politiques).
   Sans dépendance. Tout est optionnel : chaque bloc ne s'active que si son balisage est présent. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var headerH = function () {
    var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--v4-header-h'), 10);
    return isNaN(v) ? 56 : v;
  };

  /* ---------- Sommaire : ouvert d'office sur grand écran, ferme après choix sur mobile, suit la lecture ---------- */
  function initToc() {
    var toc = document.querySelector('[data-v4c-toc]');
    if (!toc) return;
    var wide = window.matchMedia('(min-width: 1180px)');
    var sync = function () { if (wide.matches) toc.setAttribute('open', ''); };
    sync();
    if (wide.addEventListener) wide.addEventListener('change', sync);
    var links = [].slice.call(toc.querySelectorAll('a[href^="#"]'));
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        if (!wide.matches) toc.removeAttribute('open');
        var y = target.getBoundingClientRect().top + window.pageYOffset - headerH() - 20;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
      });
    });
    var heads = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var queued = false;
    function spy() {
      queued = false;
      var lim = window.innerHeight * 0.3, cur = -1;
      for (var i = 0; i < heads.length; i++) { if (heads[i] && heads[i].getBoundingClientRect().top < lim) cur = i; }
      links.forEach(function (a, i) { a.classList.toggle('is-active', i === cur); });
    }
    window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(spy); } }, { passive: true });
    spy();
  }

  /* ---------- Article : barre de progression + barre produit collante ---------- */
  function initArticle() {
    var root = document.querySelector('[data-v4c-article]');
    if (!root) return;
    var bar = root.querySelector('[data-v4c-progress]');
    var prose = root.querySelector('.v4c-prose');
    var shop = root.querySelector('[data-v4c-shop]');
    var sticky = root.querySelector('[data-v4c-sticky]');
    if (sticky) sticky.hidden = false;
    var ticking = false;
    function update() {
      ticking = false;
      if (!prose) return;
      var r = prose.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = r.height - vh * 0.6;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      if (sticky) {
        var shopTop = shop ? shop.getBoundingClientRect().top : r.bottom;
        var on = r.top < -320 && shopTop > vh;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        var link = sticky.querySelector('a');
        if (link) link.tabIndex = on ? 0 : -1;
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- Partager (feuille native mobile, sinon copie du lien) ---------- */
  function initShare() {
    [].forEach.call(document.querySelectorAll('[data-v4c-share]'), function (btn) {
      btn.addEventListener('click', function () {
        var url = location.href.split('#')[0];
        var title = btn.getAttribute('data-title') || document.title;
        if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
        var done = function () {
          var label = btn.querySelector('.v4c-share__label');
          var prev = label ? label.textContent : '';
          if (label) label.textContent = btn.getAttribute('data-copied') || prev;
          btn.classList.add('is-done');
          setTimeout(function () { if (label) label.textContent = prev; btn.classList.remove('is-done'); }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () {});
      });
    });
  }

  /* ---------- Tableaux de la prose : enveloppe défilante + fondu tant qu'il reste à défiler ---------- */
  function initTables() {
    [].forEach.call(document.querySelectorAll('.v4c-prose table'), function (t) {
      if (t.parentElement && t.parentElement.classList.contains('v4c-table')) return;
      var w = document.createElement('div');
      w.className = 'v4c-table';
      w.setAttribute('tabindex', '0');
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
      var check = function () {
        var fit = w.scrollWidth <= w.clientWidth + 2;
        w.classList.toggle('v4c-table--fit', fit);
        w.classList.toggle('is-end', fit || w.scrollLeft + w.clientWidth >= w.scrollWidth - 4);
      };
      w.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
    });
  }

  /* ---------- Politiques : « <strong>Intitulé</strong> — texte » devient un bloc titré ; paragraphes vides retirés ---------- */
  function initPolicy() {
    var body = document.querySelector('.shopify-policy__body');
    if (!body) return;
    [].forEach.call(body.querySelectorAll('p, div'), function (p) {
      if (!p.children.length && !p.textContent.replace(/[\s ]/g, '')) { p.parentNode && p.parentNode.removeChild(p); }
    });
    [].forEach.call(body.querySelectorAll('p'), function (p) {
      var first = p.firstChild;
      while (first && first.nodeType === 3 && !first.textContent.replace(/[\s ]/g, '')) first = first.nextSibling;
      if (!first || first.nodeType !== 1 || !/^(STRONG|B)$/.test(first.tagName)) return;
      var next = first.nextSibling;
      if (!next || next.nodeType !== 3 || !/^[\s ]*[—–:-]/.test(next.textContent)) return;
      next.textContent = next.textContent.replace(/^[\s ]*[—–:-][\s ]*/, '');
      var t = document.createElement('span');
      t.className = 'v4c-pblock__t';
      t.textContent = first.textContent.trim();
      p.replaceChild(t, first);
      p.classList.add('v4c-pblock');
    });
  }

  /* ---------- Contact : focus sur le message de retour, champ commande selon le sujet ---------- */
  function initContact() {
    var msg = document.querySelector('[data-v4c-focus]');
    if (msg) {
      var card = document.getElementById('v4c-form');
      if (card) card.scrollIntoView({ block: 'start', behavior: 'auto' });
      try { msg.focus({ preventScroll: true }); } catch (e) { msg.focus(); }
    }
    var order = document.querySelector('[data-v4c-order]');
    if (!order) return;
    [].forEach.call(document.querySelectorAll('[data-v4c-subject]'), function (r) {
      r.addEventListener('change', function () {
        var k = r.getAttribute('data-v4c-subject');
        var need = k === 'c_sub_order' || k === 'c_sub_return';
        order.hidden = !need && !(order.querySelector('input').value);
        if (need) { var i = order.querySelector('input'); if (i && window.matchMedia('(min-width: 768px)').matches) i.focus(); }
      });
    });
  }

  /* ---------- Prose : titre répété en tête de contenu masqué ; lettrine sur le 1er vrai paragraphe ---------- */
  function initProse() {
    var prose = document.querySelector('.v4c-prose');
    if (!prose) return;
    var h1 = document.querySelector('.v4c h1');
    var norm = function (t) { return (t || '').replace(/[\s ]+/g, ' ').trim().toLowerCase(); };
    var first = prose.firstElementChild;
    if (first && h1 && /^(P|H1|H2|H3)$/.test(first.tagName) && norm(first.textContent) === norm(h1.textContent)) first.classList.add('v4c-dup');
    if (!prose.classList.contains('v4c-prose--drop')) return;
    var p1 = prose.querySelector(':scope > p');
    if (p1 && norm(p1.textContent).length >= 120 && !p1.classList.contains('v4c-dup')) return;
    var ps = prose.querySelectorAll(':scope > p');
    for (var i = 0; i < ps.length; i++) {
      if (!ps[i].classList.contains('v4c-dup') && norm(ps[i].textContent).length >= 120 && /^[A-Za-zÀ-ÿ]/.test(norm(ps[i].textContent))) {
        prose.classList.add('v4c-nodrop'); ps[i].classList.add('v4c-dropcap'); return;
      }
    }
    prose.classList.add('v4c-nodrop');
  }

  function init() { initProse(); initToc(); initArticle(); initShare(); initTables(); initPolicy(); initContact(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
